import React from "react";

const Dropdwon = ({ children, className, title, dropRef }) => {
  return (
    <div className={className} ref={dropRef}>
      <p>{title}</p>
      {children}
    </div>
  );
};

export default Dropdwon;
